import React from 'react';

const SubMenuHouseTech = () => {
    return (
        <>
            <option value="Пылесосы">Пылесосы</option>
            <option value="Кондиционеры">Кондиционеры</option>
            <option value="Индивидуальный уход">Индивидуальный уход</option>
            <option value="Стиральные машины">Стиральные машины</option>
            <option value="Стационарные телефоны">Стационарные телефоны</option>
            <option value="Швейные машины">Швейные машины</option>

        </>
    );
};

export default SubMenuHouseTech;